import { FieldValues, Resolver } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ZodType } from 'zod';

/**
 * `zodResolver` whose error messages are UILM keys translated on the way out, so schemas can carry
 * keys (`'NAME_REQUIRED'`) instead of English text -- the same convention the other modules use.
 */
export const translatedResolver =
  <TValues extends FieldValues>(
    schema: ZodType<TValues, any, any>,
    t: (key: string) => string
  ): Resolver<TValues> =>
  async (data, context, options) => {
    const result = await zodResolver(schema)(data, context, options);
    if (result.errors) {
      result.errors = Object.fromEntries(
        Object.entries(result.errors).map(([key, error]) => [
          key,
          { ...(error as object), message: t((error as { message?: string }).message ?? '') },
        ])
      ) as typeof result.errors;
    }
    return result;
  };
